import React from 'react'
import ReactPlayer from 'react-player'

class Video extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        css={{
          boxShadow: '0 0px 5px rgba(0, 0, 0, .1), 0 5px 5px rgba(0, 0, 0, .1)',
          paddingTop: this.props.ratio > 16/9 ? `${100 / (16 / 9)}%` : `${100 / this.props.ratio}%`,
          position: 'relative',
          width: '100%',
        }}
      >
        <ReactPlayer
          css={{
            left: 0,
            position: 'absolute',
            top: 0,
          }}
          url={this.props.url}
          width={'100%'}
          height={'100%'}
        />
      </div>
    )
  }
}

export default Video


// WEBPACK FOOTER //
// ./src/components/Video.js